import { render, staticRenderFns } from "./ProjectRegister.vue?vue&type=template&id=49b8600c&scoped=true"
import script from "./ProjectRegister.vue?vue&type=script&lang=js"
export * from "./ProjectRegister.vue?vue&type=script&lang=js"
import style0 from "./ProjectRegister.vue?vue&type=style&index=0&id=49b8600c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b8600c",
  null
  
)

export default component.exports